var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gantt-elastic__task-list-item-column",
      style: _vm.itemColumnStyle,
    },
    [
      _c(
        "div",
        {
          staticClass: "gantt-elastic__task-list-item-value-wrapper",
          style: _vm.wrapperStyle,
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gantt-elastic__task-list-item-value-container",
              style: _vm.containerStyle,
            },
            [
              !_vm.html && !_vm.column.render
                ? _c(
                    "div",
                    {
                      staticClass: "gantt-elastic__task-list-item-value",
                      style: _vm.valueStyle,
                      on: {
                        click: function ($event) {
                          return _vm.emitEvent("click", $event)
                        },
                        mouseenter: function ($event) {
                          return _vm.emitEvent("mouseenter", $event)
                        },
                        mouseover: function ($event) {
                          return _vm.emitEvent("mouseover", $event)
                        },
                        mouseout: function ($event) {
                          return _vm.emitEvent("mouseout", $event)
                        },
                        mousemove: function ($event) {
                          return _vm.emitEvent("mousemove", $event)
                        },
                        mousedown: function ($event) {
                          return _vm.emitEvent("mousedown", $event)
                        },
                        mouseup: function ($event) {
                          return _vm.emitEvent("mouseup", $event)
                        },
                        mousewheel: function ($event) {
                          return _vm.emitEvent("mousewheel", $event)
                        },
                        touchstart: function ($event) {
                          return _vm.emitEvent("touchstart", $event)
                        },
                        touchmove: function ($event) {
                          return _vm.emitEvent("touchmove", $event)
                        },
                        touchend: function ($event) {
                          return _vm.emitEvent("touchend", $event)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")]
                  )
                : _vm.column.render
                ? _c("Render", {
                    attrs: {
                      render: () => _vm.column.render(_vm.value, _vm.task),
                    },
                  })
                : _c("div", {
                    staticClass: "gantt-elastic__task-list-item-value",
                    style: _vm.valueStyle,
                    domProps: { innerHTML: _vm._s(_vm.value) },
                    on: {
                      click: function ($event) {
                        return _vm.emitEvent("click", $event)
                      },
                      mouseenter: function ($event) {
                        return _vm.emitEvent("mouseenter", $event)
                      },
                      mouseover: function ($event) {
                        return _vm.emitEvent("mouseover", $event)
                      },
                      mouseout: function ($event) {
                        return _vm.emitEvent("mouseout", $event)
                      },
                      mousemove: function ($event) {
                        return _vm.emitEvent("mousemove", $event)
                      },
                      mousedown: function ($event) {
                        return _vm.emitEvent("mousedown", $event)
                      },
                      mouseup: function ($event) {
                        return _vm.emitEvent("mouseup", $event)
                      },
                      mousewheel: function ($event) {
                        return _vm.emitEvent("mousewheel", $event)
                      },
                      touchstart: function ($event) {
                        return _vm.emitEvent("touchstart", $event)
                      },
                      touchmove: function ($event) {
                        return _vm.emitEvent("touchmove", $event)
                      },
                      touchend: function ($event) {
                        return _vm.emitEvent("touchend", $event)
                      },
                    },
                  }),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }